var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconNoDataProject = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 220,
    height: 178,
    viewBox: "0 0 220 178",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 110,
    cy: 88,
    r: 80,
    fill: "#E4E4E4"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 26,
    cy: 28,
    r: 8,
    fill: "#E0E0E1"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 198,
    cy: 134,
    r: 6,
    fill: "#E0E0E1"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 25,
    cy: 146,
    r: 10,
    fill: "#E0E0E1"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 210,
    cy: 54,
    r: 10,
    fill: "#E0E0E1"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 191,
    cy: 19,
    r: 7,
    fill: "#E0E0E1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_3775_74287)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M110 54.9531V137.383L46 109.74L46.3053 27.6077L110 54.9531Z",
    fill: "url(#paint0_linear_3775_74287)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.001 55.0021V137.432L173.69 110.744V27.8706L110.001 55.0021Z",
    fill: "url(#paint1_linear_3775_74287)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110 54.9529L174 28.1466L110.503 0L46 27.4765L110 54.9529Z",
    fill: "#E0E0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.1256 17.1998L133.881 44.9503L134.461 65.173L152.299 57.8126L151.759 37.4622L86.1173 10.3877L70.1256 17.1998Z",
    fill: "#D9D9D9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_3775_74287",
    x: 26,
    y: 0,
    width: 168,
    height: 177.432,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_3775_74287"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3775_74287"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_dropShadow_3775_74287"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 20
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_3775_74287",
    result: "effect2_dropShadow_3775_74287"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_3775_74287",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3775_74287",
    x1: 78,
    y1: 27.6077,
    x2: 78,
    y2: 137.383,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0DFDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3775_74287",
    x1: 141.846,
    y1: 27.8706,
    x2: 141.846,
    y2: 137.432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D1D1"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconNoDataProject);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-no-data-project.b7625e686c22a0c106172077f4148c1d.svg";